import userSearchBarUrl from './user-search-bar.html';

class UserSearchBarCtrl {
  filterUsers(searchValue) {
    const searchText = searchValue.toLowerCase();
    this.filteredUsers = this.users.filter((user) => {
      const { fullname, location, position } = user;
      return (
        fullname.toLowerCase().includes(searchText) ||
        location.toLowerCase().includes(searchText) ||
        position.toLowerCase().includes(searchText)
      );
    });
    this.onFilter({ users: this.filteredUsers });
  }
}

export default {
  controller: UserSearchBarCtrl,
  controllerAs: 'ctrl',
  bindings: {
    users: '<',
    onFilter: '&',
  },
  templateUrl: userSearchBarUrl,
};
